import { Reducer } from "redux";

import { DownLoadNotesResponse } from "../models/Api/Notes";
import { DownLoadDisciplineNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { DownloadDisciplineNoteActionDispatchType } from "../constants/Notes";

export const initialState: DownLoadNotesResponse = {
  loading: false,
  response: [
    {
      noteEntryId: -1,
      noteTemplateId: -1,
      noteEntryJson: "",
      templateVersionId: -1,
      templateName: "",
      fullNameCreated: "",
    },
  ],
};

const DownDisciplineNotesReducer: Reducer<
  DownLoadNotesResponse,
  DownLoadDisciplineNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DownloadDisciplineNoteActionDispatchType.POST_DOWNLOAD_DISCIPLINE_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DownloadDisciplineNoteActionDispatchType.POST_DOWNLOAD_DISCIPLINE_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DownloadDisciplineNoteActionDispatchType.POST_DOWNLOAD_DISCIPLINE_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DownDisciplineNotesReducer;
